var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DebugPlayerWatcher',{attrs:{"data":_vm._debug}}),_c('div',{staticClass:"youtube",attrs:{"id":"ytcontainer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }